import React from 'react';
import { FeatureCallout } from '../../../common/FeatureElements';
import { Title } from '../../../dashboard/elements/LayoutElements';
import { UpgradeButton } from '../../../upgrade/UpgradeButton';

export const SingleSignOnPremiumCallout = () =>
    <FeatureCallout maxWidth="64">
        <Title>Please upgrade to either our Business or Enterprise plan to enable Single Sign-On (SAML).</Title>
        <UpgradeButton variant="common" />
    </FeatureCallout>;

